import { render, staticRenderFns } from "./EnableDisableVideo.vue?vue&type=template&id=5dc3790e&scoped=true"
import script from "./EnableDisableVideo.vue?vue&type=script&lang=js"
export * from "./EnableDisableVideo.vue?vue&type=script&lang=js"
import style0 from "./EnableDisableVideo.vue?vue&type=style&index=0&id=5dc3790e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc3790e",
  null
  
)

export default component.exports